/**
 * Created by cuppi on 2016/11/29.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const JUrlList_1 = require("../unify/JUrlList");
const JToolDate_1 = require("../tool/JToolDate");
const JDataUnify_1 = require("../unify/JDataUnify");
const JManagerSeat_1 = require("../util/JManagerSeat");
const JNetworkRoot_1 = require("./JNetworkRoot");
/**
 * 影院接口
 * @memberOf module:network
 */
class JNetworkCinema extends JNetworkRoot_1.default {
    /**
     * 获取影院详情
     * @param {string} cinemaId 影院ID
     * @returns {Promise} promise
     */
    cinemaDetail(cinemaId) {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzDetail, { cinemaId }).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzDetail', data, 0));
            }, error => {
                reject(error);
            });
        });
    }
    cinemaList(location, cinemaFilter) {
        if (cinemaFilter == undefined) {
            cinemaFilter = location;
        }
        return new Promise((resolve, reject) => {
            let u = undefined;
            let { filmId, feature, region, sort, limit } = cinemaFilter ? cinemaFilter : { filmId: u, feature: u, region: u, sort: u, limit: u };
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzList, Object.assign({}, location, { filmId,
                feature, regionName: region, orderType: sort, limit })).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzList', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 获取指定影院排片
     * @param cinemaId 影院Id
     * @returns {{terminate, then}|*}
     */
    cinemaScreeningFilmList(cinemaId) {
        return new Promise((resolve, reject) => {
            return this.prefixPromise(JUrlList_1.cinemaUrl.jbzScreeningFilmList, {
                cinemaId
            }).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzScreeningFilmList', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 获取指定影院排片日期安排
     * @param cinemaId 影院Id
     * @param filmId 影片Id
     * @returns {{terminate, then}|*}
     */
    cinemaScreeningDateList(cinemaId, filmId) {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzScreeningDateList, { cinemaId, filmId }).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzScreeningDateList', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 获取指定影院排片放映厅安排
     * @param cinemaId 影院Id
     * @param filmId 影片Id
     * @param date 日期（时间戳标示）
     * @returns {{terminate, then}|*}
     */
    cinemaScreeningItems(cinemaId, filmId, date) {
        return new Promise((resolve, reject) => {
            date = JToolDate_1.default.dateStringFromTimeInterval(date, 'yyyy-MM-dd');
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzScreeningItems, { cinemaId, filmId, date }).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzScreeningItems', data));
            }, error => {
                reject(error);
            });
        });
    }
    ;
    /**
     * 实时座位图
     * @param type 平台类型 （必须）
     * @param paras （根据不同平台变化）
     * @returns {*}
     */
    cinemaSeats(type, paras) {
        if (type === 'meituan' || type === 'dazhong') {
            type = 'maoyan';
        }
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzRealtimeSeat, Object.assign({ type }, paras)).then(data => {
                resolve(JDataUnify_1.default('cinemaUrl.jbzRealtimeSeat', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 智能实时座位图
     * @param type 平台类型 （必须）
     * @param paras （根据不同平台变化）
     * @returns {*}
     */
    cinemaSmartSeats(type, paras) {
        if (type === 'meituan' || type === 'dazhong') {
            type = 'maoyan';
        }
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.cinemaUrl.jbzRealtimeSeat, Object.assign({ type }, paras)).then(data => {
                resolve(JManagerSeat_1.default.defaultManager().smartSeatsFromSeats(type, JDataUnify_1.default('cinemaUrl.jbzRealtimeSmartSeat', data)));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 收藏影院
     * @param cinemaId 影院Id
     * @param cinemaName 影院名字
     * @returns {{terminate, then}|*}
     */
    cinemaFavoriteCinema(cinemaId, cinemaName) {
        return this.prefixPromise(JUrlList_1.cinemaUrl.jbzCollectcinema, {
            cinemaId: cinemaId,
            cinemaName: cinemaName
        });
    }
    /**
     * 取消收藏影院
     * @param cinemaId 影院Id
     * @returns {{terminate, then}|*}
     */
    cinemaCancelFavoriteCinema(cinemaId) {
        return this.prefixPromise(JUrlList_1.cinemaUrl.jbzCancelcollectcinema, {});
    }
    static cinemaDetail(cinemaId) {
        return this.instance().cinemaDetail(cinemaId);
    }
    static cinemaList(a, b) {
        return this.instance().cinemaList(a, b);
    }
    static cinemaScreeningFilmList(cinemaId) {
        return this.instance().cinemaScreeningFilmList(cinemaId);
    }
    static cinemaScreeningDateList(cinemaId, filmId) {
        return this.instance().cinemaScreeningDateList(cinemaId, filmId);
    }
    static cinemaScreeningItems(cinemaId, filmId, date) {
        return this.instance().cinemaScreeningItems(cinemaId, filmId, date);
    }
    ;
    static cinemaSeats(type, paras) {
        return this.instance().cinemaSeats(type, paras);
    }
    static cinemaSmartSeats(type, paras) {
        return this.instance().cinemaSmartSeats(type, paras);
    }
    static cinemaFavoriteCinema(cinemaId, cinemaName) {
        return this.instance().cinemaFavoriteCinema(cinemaId, cinemaName);
    }
    static cinemaCancelFavoriteCinema(cinemaId) {
        return this.instance().cinemaCancelFavoriteCinema(cinemaId);
    }
}
exports.default = JNetworkCinema;
